import React from 'react';
import { Box } from '@wix/design-system';
import { TldAlternativeCard } from './TldAlternativeCard';
import { TldAlternativesSkeleton } from './TldAlternativesSkeleton';
export const TldAlternatives = _ref => {
  let {
    alternatives,
    isLoading,
    disabled,
    onClickGetIt,
    dataHook,
    useMobileLayout = false,
    useFullWidthSkeleton = false
  } = _ref;
  if (isLoading) {
    return /*#__PURE__*/React.createElement(TldAlternativesSkeleton, {
      limit: 3,
      useMobileLayout: useMobileLayout,
      useFullWidthSkeleton: useFullWidthSkeleton
    });
  }
  if (!alternatives.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: useMobileLayout ? 'vertical' : 'horizontal',
    gap: useMobileLayout ? 'SP3' : '18px',
    width: "100%",
    flexWrap: useMobileLayout ? 'nowrap' : 'wrap',
    dataHook: dataHook
  }, alternatives.map((alternative, index) => /*#__PURE__*/React.createElement(TldAlternativeCard, {
    key: alternative.id ?? alternative.domain ?? index,
    recommendation: alternative,
    onClick: onClickGetIt,
    disabled: disabled,
    dataHook: dataHook ? `${dataHook}-item-${index}` : undefined,
    useMobileLayout: useMobileLayout
  })));
};
//# sourceMappingURL=TldAlternatives.js.map